import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Check, X, ExternalLink, RefreshCw } from 'lucide-react';
import { formatApiError } from '../../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const WithdrawalsTab = () => {
  const [status, setStatus] = useState('pending');
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      setLoading(true); setErr('');
      const { data } = await axios.get(`${API}/fantasy/admin/withdrawals`, { params: { status } });
      setRows(data);
    } catch (ex) { setErr(formatApiError(ex)); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const decide = async (row, approve) => {
    const label = approve ? `Aprovar saque de ${row.net_eur}€ para ${row.user_name}?` : `Rejeitar saque de ${row.user_name}?`;
    if (!window.confirm(label)) return;
    try {
      await axios.post(`${API}/fantasy/admin/withdrawals/decide`, { id: row.id, approve });
      await load();
    } catch (ex) { alert(formatApiError(ex)); }
  };

  const waLink = (row) =>
    `https://wa.me/${(row.user_email || '').replace(/\D/g, '')}?text=` +
    encodeURIComponent(`Olá ${row.user_name}! Vou processar o teu saque de ${row.net_eur}€ (${row.net_pc} PC líquido) por MB WAY. Confirmas o número que vou pagar?`);

  return (
    <div>
      <div className="flex flex-wrap gap-2 mb-4">
        {[{k:'pending',l:'Pendentes'},{k:'paid',l:'Pagos'},{k:'rejected',l:'Rejeitados'}].map((s) => (
          <button key={s.k} onClick={() => setStatus(s.k)}
            className={`px-4 py-2 rounded-lg text-sm font-medium ${status === s.k ? 'bg-emerald-500 text-slate-900' : 'bg-slate-800/60 text-slate-300 hover:bg-slate-700/60'}`}
            data-testid={`withdrawals-status-${s.k}`}>{s.l}</button>
        ))}
        <button onClick={load} className="ml-auto px-3 py-2 rounded-lg text-sm text-slate-300 hover:bg-white/5" data-testid="withdrawals-refresh"><RefreshCw className="w-4 h-4" /></button>
      </div>

      {err && <div className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2 mb-4">{err}</div>}

      <div className="bg-slate-900/60 border border-white/10 rounded-2xl overflow-hidden">
        {loading ? <div className="p-6 text-slate-300">A carregar...</div>
          : rows.length === 0 ? <div className="p-6 text-slate-400 text-center">Sem pedidos.</div>
          : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="text-left text-xs text-slate-400 uppercase border-b border-white/10">
                  <tr>
                    <th className="px-4 py-3">Utilizador</th>
                    <th className="px-4 py-3 text-right">Total (PC)</th>
                    <th className="px-4 py-3 text-right">Taxa (PC)</th>
                    <th className="px-4 py-3 text-right">Líquido</th>
                    <th className="px-4 py-3">Estado</th>
                    <th className="px-4 py-3 text-right">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`withdraw-row-${r.id}`}>
                      <td className="px-4 py-3">
                        <div className="text-white font-medium">{r.user_name}</div>
                        <div className="text-slate-400 text-xs">{r.user_email}</div>
                      </td>
                      <td className="px-4 py-3 text-right text-white tabular-nums">{r.amount_pc}</td>
                      <td className="px-4 py-3 text-right text-amber-300 tabular-nums">{r.fee_pc}</td>
                      <td className="px-4 py-3 text-right">
                        <div className="text-emerald-300 font-black tabular-nums">{r.net_eur.toFixed(2)}€</div>
                        <div className="text-slate-500 text-[10px]">{r.net_pc} PC</div>
                      </td>
                      <td className="px-4 py-3">
                        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold border ${
                          r.status === 'paid' ? 'bg-emerald-500/20 text-emerald-300 border-emerald-400/30' :
                          r.status === 'pending' ? 'bg-amber-500/20 text-amber-300 border-amber-400/30' :
                                                   'bg-red-500/20 text-red-300 border-red-400/30'
                        }`}>{r.status}</span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center justify-end gap-1">
                          {r.status === 'pending' && (
                            <>
                              <a href={waLink(r)} target="_blank" rel="noopener noreferrer" className="p-1.5 rounded-lg bg-slate-800 text-slate-300 hover:text-white" title="Combinar MB WAY"><ExternalLink className="w-3.5 h-3.5" /></a>
                              <button onClick={() => decide(r, true)} className="p-1.5 rounded-lg bg-emerald-500/20 text-emerald-300 hover:bg-emerald-500/30" title="Aprovar" data-testid={`withdraw-approve-${r.id}`}><Check className="w-3.5 h-3.5" /></button>
                              <button onClick={() => decide(r, false)} className="p-1.5 rounded-lg bg-red-500/20 text-red-300 hover:bg-red-500/30" title="Rejeitar" data-testid={`withdraw-reject-${r.id}`}><X className="w-3.5 h-3.5" /></button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
      </div>
    </div>
  );
};

export default WithdrawalsTab;
